import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import colors from "core/resources/theme/colors";
import { BsCashStack } from "react-icons/bs";

import { SimpleGrid } from "@chakra-ui/layout";
import Card1HorizontalConciliacaoBancaria from "./components/Card1HorizontalConciliacaoBancaria/index";

function DashboardConciliacao({
  totais,
  isLoading,
}: {
  totais?: {
    creditoDiferenca: number;
    debitoDiferenca: number;
    saldoInicial: number;
    saldoFinal: number;
  };
  isLoading?: boolean;
}) {
  const creditoDiferenca = totais?.creditoDiferenca || 0;
  const debitoDiferenca = totais?.debitoDiferenca || 0;
  const saldoInicial = totais?.saldoInicial || 0;
  const saldoFinal = totais?.saldoFinal || 0;

  const getColorForValue = (value: number) => {
    if (value < 0) {
      return colors.accentNegative;
    } else if (value > 0) {
      return colors.accentPositive;
    }
  };

  const getBgForValue = (value: number) => {
    if (value < 0) {
      return colors.accentNegative + "26";
    }
    return colors.accentPositive + "26";
  };

  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
        <Card1HorizontalConciliacaoBancaria
          icon={<BsCashStack fontSize="24px" color={colors.accentPositive} />}
          color={colors.accentPositive}
          bg={colors.accentPositive + "26"}
          description="Créditos de Diferença"
          title={`R$ ${formatCurrency(creditoDiferenca)}`}
          loading={isLoading}
        />

        <Card1HorizontalConciliacaoBancaria
          icon={<BsCashStack fontSize="24px" color={colors.accentNegative} />}
          color={colors.accentNegative}
          bg={colors.accentNegative + "26"}
          description="Débitos de Diferença"
          title={`R$ ${formatCurrency(debitoDiferenca)}`}
          colorTitle={colors.accentNegative}
          loading={isLoading}
        />

        <Card1HorizontalConciliacaoBancaria
          icon={
            <BsCashStack
              fontSize="24px"
              color={getColorForValue(saldoInicial) || colors.accentPositive}
            />
          }
          color={getColorForValue(saldoInicial) || colors.accentPositive}
          bg={colors.green100}
          description="Saldo Inicial"
          title={`R$ ${formatCurrency(saldoInicial)}`}
          colorTitle={getColorForValue(saldoInicial)}
          loading={isLoading}
        />

        <Card1HorizontalConciliacaoBancaria
          icon={
            <BsCashStack
              fontSize="24px"
              color={getColorForValue(saldoFinal) || colors.accentPositive}
            />
          }
          color={getColorForValue(saldoFinal) || colors.accentPositive}
          bg={getBgForValue(saldoFinal)}
          description="Saldo Final"
          title={`R$ ${formatCurrency(saldoFinal)}`}
          colorTitle={getColorForValue(saldoFinal)}
          loading={isLoading}
        />
      </SimpleGrid>
    </>
  );
}

export default DashboardConciliacao;
